// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.idpHighlightSelect__container {
  position: relative;
  width: 100%;
  font: inherit;
  color: inherit;
  box-sizing: border-box;
}[dir] .idpHighlightSelect__container {
  margin: 10px 0;
}

/* Closed control — matches the existing .advancedSelect look */
.idpHighlightSelect__control {
  display: flex;
  align-items: center;
  width: 100%;
  min-height: 40px;
  transition: box-shadow 0.1s ease-in-out;
  box-sizing: border-box;
}
[dir] .idpHighlightSelect__control {
  background-color: white;
  border: none;
  border-radius: 5px;
  box-shadow: none;
  cursor: pointer;
}
[dir=ltr] .idpHighlightSelect__control {
  padding: 0 8px 0 15px;
}
[dir=rtl] .idpHighlightSelect__control {
  padding: 0 15px 0 8px;
}

.idpHighlightSelect__control--is-focused,
.idpHighlightSelect__control--menu-is-open {
  outline: none;
}

[dir] .idpHighlightSelect__control--is-focused, [dir] .idpHighlightSelect__control--menu-is-open {
  box-shadow: 0 0 0 2px #e6512d;
}

.idpHighlightSelect__value-container {
  display: flex;
  flex: 1 1 auto;
  align-items: center;
  overflow: hidden;
}

[dir] .idpHighlightSelect__value-container {
  padding: 0;
}

.idpHighlightSelect__single-value,
.idpHighlightSelect__placeholder {
  color: inherit;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

[dir] .idpHighlightSelect__single-value, [dir] .idpHighlightSelect__placeholder {
  margin: 0;
}

.idpHighlightSelect__input-container {
  color: inherit;
  display: grid;
  grid-template-columns: 0;
}

[dir] .idpHighlightSelect__input-container {
  margin: 0;
  padding: 0;
}

.idpHighlightSelect__input-container input {
  font: inherit;
  color: inherit;
}

.idpHighlightSelect__indicators {
  display: flex;
  align-items: center;
  flex-shrink: 0;
}

.idpHighlightSelect__dropdown-indicator {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #f59201;
}

[dir] .idpHighlightSelect__dropdown-indicator {
  padding: 0 4px;
}

/* Portal wrapper — sits above modal/header layers */
.idpHighlightSelect__menu-portal {
  z-index: 9999;
}

/* Open menu — dark surface per design.
   Positioning is handled by react-select on the portal wrapper. */
.idpHighlightSelect__menu {
  color: #ffffff;
  overflow: hidden;
}
[dir] .idpHighlightSelect__menu {
  margin-top: 4px;
  background-color: #4a4a4a;
  border-radius: 5px;
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.25);
}

.idpHighlightSelect__menu-list {
  max-height: 360px;
  overflow-y: auto;
}

[dir] .idpHighlightSelect__menu-list {
  padding: 0;
}

/* Group label — "CUSTOM GROUPS" divider */
[dir] .idpHighlightSelect__group {
  padding: 0;
}

[dir] .idpHighlightSelect__group + .idpHighlightSelect__group {
  border-top: 1px solid rgba(255, 255, 255, 0.18);
  margin-top: 6px;
  padding-top: 6px;
}

.idpHighlightSelect__group-heading {
  color: rgba(255, 255, 255, 0.6);
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

[dir] .idpHighlightSelect__group-heading {
  padding: 8px 18px 4px;
  margin: 0;
}

/* Options */
.idpHighlightSelect__option {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #ffffff;
}
[dir] .idpHighlightSelect__option {
  padding: 4px 18px;
  background-color: transparent;
  cursor: pointer;
}

[dir] .idpHighlightSelect__option--is-focused {
  background-color: rgba(255, 255, 255, 0.08);
}

.idpHighlightSelect__option--is-selected {
  color: #ffffff;
}

[dir] .idpHighlightSelect__option--is-selected {
  background-color: transparent;
}

/* When the menu opens, react-select auto-focuses the selected option.
   The mock shows no overlay on that row — only the ✓ indicates selection. */
[dir] .idpHighlightSelect__option--is-selected.idpHighlightSelect__option--is-focused {
  background-color: transparent;
}

[dir] .idpHighlightSelect__option:active {
  background-color: rgba(255, 255, 255, 0.12);
}

.idpHighlightSelect__check {
  display: inline-block;
  width: 14px;
  color: #ffffff;
  flex-shrink: 0;
}

[dir] .idpHighlightSelect__check {
  text-align: center;
}

.idpHighlightSelect__optionLabel {
  flex: 1;
  line-height: 1.3;
}

/* Placeholder row ("Select group to highlight") — muted to match the
   "Custom groups" heading. It stays selectable, just visually de-emphasised. */
.idpHighlightSelect__optionLabel--muted {
  color: rgba(255, 255, 255, 0.6);
}
`, "",{"version":3,"sources":["webpack://./src/js/components/SettingsPanel/subComponents/GroupHighlightSelectField/styles.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,WAAW;EAEX,aAAa;EACb,cAAc;EACd,sBAAsB;AACxB,CAPA;EAGE,cAAc;AAIhB;;AAEA,+DAA+D;AAC/D;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAOhB,uCAAuC;EACvC,sBAAsB;AACxB;AAbA;EAKE,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAElB,gBAAgB;EAChB,eAAe;AAGjB;AAbA;EAQE,qBAAqB;AAKvB;AAbA;EAQE,qBAAqB;AAKvB;;AAEA;;EAGE,aAAa;AACf;;AAJA;EAEE,6BAA6B;AAE/B;;AAEA;EACE,aAAa;EACb,cAAc;EACd,mBAAmB;EAEnB,gBAAgB;AAClB;;AANA;EAIE,UAAU;AAEZ;;AAEA;;EAEE,cAAc;EAEd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAPA;EAGE,SAAS;AAIX;;AAEA;EAGE,cAAc;EACd,aAAa;EACb,wBAAwB;AAC1B;;AANA;EACE,SAAS;EACT,UAAU;AAIZ;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EAEvB,cAAc;AAChB;;AANA;EAIE,cAAc;AAEhB;;AAEA,oDAAoD;AACpD;EACE,aAAa;AACf;;AAEA;kEACkE;AAClE;EAGE,cAAc;EAEd,gBAAgB;AAElB;AAPA;EACE,eAAe;EACf,yBAAyB;EAEzB,kBAAkB;EAElB,0CAA0C;AAC5C;;AAEA;EAEE,iBAAiB;EACjB,gBAAgB;AAClB;;AAJA;EACE,UAAU;AAGZ;;AAEA,0CAA0C;AAC1C;EACE,UAAU;AACZ;;AAEA;EACE,+CAA+C;EAC/C,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAG3B;;AARA;EAME,qBAAqB;EACrB,SAAS;AACX;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EAER,cAAc;AAGhB;AARA;EAIE,iBAAiB;EAEjB,6BAA6B;EAC7B,eAAe;AACjB;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EAEE,cAAc;AAChB;;AAHA;EACE,6BAA6B;AAE/B;;AAEA;4EAC4E;AAC5E;EACE,6BAA6B;AAC/B;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,qBAAqB;EACrB,WAAW;EAEX,cAAc;EACd,cAAc;AAChB;;AANA;EAGE,kBAAkB;AAGpB;;AAEA;EACE,OAAO;EACP,gBAAgB;AAClB;;AAEA;+EAC+E;AAC/E;EACE,+BAA+B;AACjC","sourcesContent":[":global(.idpHighlightSelect__container) {\n  position: relative;\n  width: 100%;\n  margin: 10px 0;\n  font: inherit;\n  color: inherit;\n  box-sizing: border-box;\n}\n\n/* Closed control — matches the existing .advancedSelect look */\n:global(.idpHighlightSelect__control) {\n  display: flex;\n  align-items: center;\n  width: 100%;\n  min-height: 40px;\n  background-color: white;\n  border: none;\n  border-radius: 5px;\n  padding: 0 8px 0 15px;\n  box-shadow: none;\n  cursor: pointer;\n  transition: box-shadow 0.1s ease-in-out;\n  box-sizing: border-box;\n}\n\n:global(.idpHighlightSelect__control--is-focused),\n:global(.idpHighlightSelect__control--menu-is-open) {\n  box-shadow: 0 0 0 2px #e6512d;\n  outline: none;\n}\n\n:global(.idpHighlightSelect__value-container) {\n  display: flex;\n  flex: 1 1 auto;\n  align-items: center;\n  padding: 0;\n  overflow: hidden;\n}\n\n:global(.idpHighlightSelect__single-value),\n:global(.idpHighlightSelect__placeholder) {\n  color: inherit;\n  margin: 0;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n:global(.idpHighlightSelect__input-container) {\n  margin: 0;\n  padding: 0;\n  color: inherit;\n  display: grid;\n  grid-template-columns: 0;\n}\n\n:global(.idpHighlightSelect__input-container input) {\n  font: inherit;\n  color: inherit;\n}\n\n:global(.idpHighlightSelect__indicators) {\n  display: flex;\n  align-items: center;\n  flex-shrink: 0;\n}\n\n:global(.idpHighlightSelect__dropdown-indicator) {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0 4px;\n  color: #f59201;\n}\n\n/* Portal wrapper — sits above modal/header layers */\n:global(.idpHighlightSelect__menu-portal) {\n  z-index: 9999;\n}\n\n/* Open menu — dark surface per design.\n   Positioning is handled by react-select on the portal wrapper. */\n:global(.idpHighlightSelect__menu) {\n  margin-top: 4px;\n  background-color: #4a4a4a;\n  color: #ffffff;\n  border-radius: 5px;\n  overflow: hidden;\n  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.25);\n}\n\n:global(.idpHighlightSelect__menu-list) {\n  padding: 0;\n  max-height: 360px;\n  overflow-y: auto;\n}\n\n/* Group label — \"CUSTOM GROUPS\" divider */\n:global(.idpHighlightSelect__group) {\n  padding: 0;\n}\n\n:global(.idpHighlightSelect__group + .idpHighlightSelect__group) {\n  border-top: 1px solid rgba(255, 255, 255, 0.18);\n  margin-top: 6px;\n  padding-top: 6px;\n}\n\n:global(.idpHighlightSelect__group-heading) {\n  color: rgba(255, 255, 255, 0.6);\n  font-size: 11px;\n  font-weight: 600;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  padding: 8px 18px 4px;\n  margin: 0;\n}\n\n/* Options */\n:global(.idpHighlightSelect__option) {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 4px 18px;\n  color: #ffffff;\n  background-color: transparent;\n  cursor: pointer;\n}\n\n:global(.idpHighlightSelect__option--is-focused) {\n  background-color: rgba(255, 255, 255, 0.08);\n}\n\n:global(.idpHighlightSelect__option--is-selected) {\n  background-color: transparent;\n  color: #ffffff;\n}\n\n/* When the menu opens, react-select auto-focuses the selected option.\n   The mock shows no overlay on that row — only the ✓ indicates selection. */\n:global(.idpHighlightSelect__option--is-selected.idpHighlightSelect__option--is-focused) {\n  background-color: transparent;\n}\n\n:global(.idpHighlightSelect__option:active) {\n  background-color: rgba(255, 255, 255, 0.12);\n}\n\n:global(.idpHighlightSelect__check) {\n  display: inline-block;\n  width: 14px;\n  text-align: center;\n  color: #ffffff;\n  flex-shrink: 0;\n}\n\n:global(.idpHighlightSelect__optionLabel) {\n  flex: 1;\n  line-height: 1.3;\n}\n\n/* Placeholder row (\"Select group to highlight\") — muted to match the\n   \"Custom groups\" heading. It stays selectable, just visually de-emphasised. */\n:global(.idpHighlightSelect__optionLabel--muted) {\n  color: rgba(255, 255, 255, 0.6);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
